import { Injectable, inject } from '@angular/core';
import { IndexType } from '@fnModels/algolia/algolia';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { getIndex } from '@state/utils/helper';
import { AlgoliaBaseState, AlgoliaSearchState } from '..';
import * as actions from './actions';
import { AlgoliaHit } from '@state/utils/models';
import { LeapApiService } from 'src/app/shared/api-repos/leap/leap-api.service';

export type LawFirmSearchStateModel = AlgoliaBaseState<unknown>;

@State<LawFirmSearchStateModel>({
	name: 'lawFirmSearch',
	defaults: {
		searchTerm: '',
		searching: false,
		success: null,
		error: null,
		items: [],
	},
})
@Injectable()
export class LawFirmSearchState extends AlgoliaSearchState<LawFirmSearchStateModel> {
	private leapApiService = inject(LeapApiService);
	protected indexName = getIndex(IndexType.LAW_FIRMS);

	@Selector([LawFirmSearchState])
	static getList(state: LawFirmSearchStateModel) {
		return state?.items;
	}

	@Selector([LawFirmSearchState])
	static getSearching(state: LawFirmSearchStateModel): boolean {
		return state?.searching;
	}

	@Action(actions.Search)
	async search(
		ctx: StateContext<LawFirmSearchStateModel>,
		{ searchTerm }: actions.Search,
	) {
		// if (this.store.selectSnapshot(SelectedMatter.isLeapMatter)) {
		// 	await this.searchLeap(ctx, searchTerm);
		// } else {
		await this.algoliaSearchHandler(ctx, searchTerm);
		//}
	}

	async searchLeap(
		{ patchState }: StateContext<LawFirmSearchStateModel>,
		searchTerm: string,
	) {
		patchState({ searching: true, searchTerm, success: false, error: null });
		if (!searchTerm) return;
		const results = await this.leapApiService
			.searchLawFirms(searchTerm)
			.toPromise();

		patchState({
			success: true,
			searching: false,
			items: results as AlgoliaHit<LawFirmSearchStateModel>[],
		});
	}
}
